import { React } from "react";
import create from "zustand";

import XRPage from "./XRPage";
import { PAGES } from "../constants";
import QRPage from "./QRPage";
import LoadingBar from "./LoadingBar";
import WebXRActivation from "./WebXRActivation";
import ARPage from "./ARPage";
// eslint-disable-next-line no-unused-vars
import EmptyPage from "./EmptyPage";
import "./Renderer.css";

const store = (set) => ({
  page: PAGES.LOADING,
  setPage: (page) => {
    console.log("Called set Page with page: ", page);
    set({ page });
  },
});

const useRendererStore = create(store);
export const RendererState = useRendererStore.getState;

const renderSwitch = (page) => {
  console.log("Rendering page", page);
  switch (page) {
    case PAGES.LOADING:
      return <LoadingBar />;
    case PAGES.QR_CODE:
      return <QRPage />;
    case PAGES.WEBXR_ACTIVATION:
      return <WebXRActivation />;
    case PAGES.XR:
      return <XRPage />;
    case PAGES.AR:
      return <ARPage />;
    // case PAGES.NO_DATA:
    //   return <EmptyPage />;
    default:
      return null;
  }
};

const Renderer = () => {
  const page = useRendererStore((state) => state.page);

  return <div className="Renderer">{renderSwitch(page)}</div>;
};

export default Renderer;
